import { Component, OnInit } from '@angular/core';
import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-casting',
  templateUrl: './casting.component.html',
  styleUrls: ['./casting.component.scss']
})
export class CastingComponent implements OnInit {
  hostName = GlobalComponent.hostName;

  constructor(private SEOService:SeoService,private router: Router) { window.scroll(0, 0);}

  ngOnInit(): void {
    this.SEOService.updateCanonicalUrl(this.hostName + '/casting');
  }
  signup()
  {
    this.router.navigate(['/login/signup']);

  }

}
